var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/controls/display-faceout-fits.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["displayOrder", "data", "selectedSizeTypeGroupId", "selectedSizeTypeCode"], 
["enabled"], 
function (l_displayOrder, l_data, l_selectedSizeTypeGroupId, l_selectedSizeTypeCode, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("displayOrder", l_displayOrder);
frame.set("data", l_data);
frame.set("selectedSizeTypeGroupId", l_selectedSizeTypeGroupId);
frame.set("selectedSizeTypeCode", l_selectedSizeTypeCode);
frame.set("enabled", kwargs.hasOwnProperty("enabled") ? kwargs["enabled"] : runtime.contextOrFrameLookup(context, frame, "True"));
var t_2 = "";if(env.getFilter("length").call(context, l_displayOrder) > 1) {
t_2 += "<div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12 o-extra-large--10 c-product-sizes__fit\">\n\n                <fieldset class=\"c-product-sizes__field-set\" data-qa-fit>\n\n                    ";
t_2 += "\n                    <legend class=\"c-form__legend c-product-sizes__legend\">";
t_2 += runtime.suppressValue((lineno = 11, colno = 77, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_sku-fits-label"])), env.opts.autoescape);
t_2 += ":</legend>\n\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "enabled")) {
t_2 += "\n\n                        <div class=\"c-radio-styled__outer\">";
frame = frame.push();
var t_5 = l_displayOrder;
if(t_5) {var t_4 = t_5.length;
for(var t_3=0; t_3 < t_5.length; t_3++) {
var t_6 = t_5[t_3];
frame.set("code", t_6);
frame.set("loop.index", t_3 + 1);
frame.set("loop.index0", t_3);
frame.set("loop.revindex", t_4 - t_3);
frame.set("loop.revindex0", t_4 - t_3 - 1);
frame.set("loop.first", t_3 === 0);
frame.set("loop.last", t_3 === t_4 - 1);
frame.set("loop.length", t_4);
t_2 += "\n\n                            ";
t_2 += runtime.suppressValue((lineno = 19, colno = 47, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_displayFaceoutFit"), "_displayFaceoutFit", context, [runtime.memberLookup((l_data),t_6),l_selectedSizeTypeGroupId,l_selectedSizeTypeCode,runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index")])), env.opts.autoescape);
;
}
}
frame = frame.pop();
t_2 += "</div>\n\n                    ";
;
}
else {
t_2 += "\n\n                        ";
if(runtime.memberLookup((l_data),l_selectedSizeTypeCode)) {
t_2 += "\n\n                            <span class=\"c-product-sizes__selected-fit\">\n\n                                ";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_data),l_selectedSizeTypeCode)),"displayName"), env.opts.autoescape);
t_2 += "\n\n                            </span>\n\n                        ";
;
}
t_2 += "\n\n                    ";
;
}
t_2 += "\n\n                </fieldset>\n\n            </div>\n\n        </div>";
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("displayFaceoutFits");
context.setVariable("displayFaceoutFits", macro_t_1);
var macro_t_7 = runtime.makeMacro(
["fit", "selectedSizeTypeGroupId", "selectedSizeTypeCode", "index"], 
[], 
function (l_fit, l_selectedSizeTypeGroupId, l_selectedSizeTypeCode, l_index, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("fit", l_fit);
frame.set("selectedSizeTypeGroupId", l_selectedSizeTypeGroupId);
frame.set("selectedSizeTypeCode", l_selectedSizeTypeCode);
frame.set("index", l_index);
var t_8 = "";if(runtime.memberLookup((l_fit),"inColor")) {
t_8 += "\n\n        ";
var t_9;
t_9 = (lineno = 60, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.backInStockEnabled"]));
frame.set("backInStockEnabled", t_9, true);
if(frame.topLevel) {
context.setVariable("backInStockEnabled", t_9);
}
if(frame.topLevel) {
context.addExport("backInStockEnabled", t_9);
}
t_8 += "\n        ";
var t_10;
t_10 = (!(lineno = 61, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["quickshop.isOpen"]))?runtime.contextOrFrameLookup(context, frame, "True"):"");
frame.set("nowrap", t_10, true);
if(frame.topLevel) {
context.setVariable("nowrap", t_10);
}
if(frame.topLevel) {
context.addExport("nowrap", t_10);
}
t_8 += "\n\n        <div class=\"c-radio-styled ";
t_8 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "nowrap")?"c-radio-styled--nowrap":""), env.opts.autoescape);
t_8 += "\">\n\n            <input type=\"radio\"\n                class=\"c-radio-styled__radio js-size-type-selection\"\n                value=\"";
t_8 += runtime.suppressValue(runtime.memberLookup((l_fit),"code"), env.opts.autoescape);
t_8 += "\"\n                ";
t_8 += runtime.suppressValue((lineno = 68, colno = 19, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","fit",runtime.memberLookup((l_fit),"code")])), env.opts.autoescape);
t_8 += "\n                name=\"productFit-";
t_8 += runtime.suppressValue(l_selectedSizeTypeGroupId, env.opts.autoescape);
t_8 += "\"\n                id=\"product-fit-";
t_8 += runtime.suppressValue(l_selectedSizeTypeGroupId, env.opts.autoescape);
t_8 += "-";
t_8 += runtime.suppressValue(l_index, env.opts.autoescape);
t_8 += "\"\n                ";
if(l_selectedSizeTypeCode == runtime.memberLookup((l_fit),"code")) {
t_8 += "checked=\"checked\"";
;
}
t_8 += "\n                ";
if(!runtime.memberLookup((l_fit),"inStock") && !runtime.contextOrFrameLookup(context, frame, "backInStockEnabled")) {
t_8 += "disabled";
;
}
t_8 += "\n                data-qa-sizetype=\"";
t_8 += runtime.suppressValue(runtime.memberLookup((l_fit),"code"), env.opts.autoescape);
t_8 += "\"\n            />\n\n            <label\n                for=\"product-fit-";
t_8 += runtime.suppressValue(l_selectedSizeTypeGroupId, env.opts.autoescape);
t_8 += "-";
t_8 += runtime.suppressValue(l_index, env.opts.autoescape);
t_8 += "\"\n                class=\"c-radio-styled__label ";
if(!runtime.memberLookup((l_fit),"inStock") && !runtime.contextOrFrameLookup(context, frame, "backInStockEnabled")) {
t_8 += "is-disabled";
;
}
t_8 += " ";
if(!runtime.memberLookup((l_fit),"inStock") && runtime.contextOrFrameLookup(context, frame, "backInStockEnabled")) {
t_8 += "is-out-of-stock";
;
}
t_8 += "\">\n\n                ";
t_8 += runtime.suppressValue(env.getFilter("capitalize").call(context, runtime.memberLookup((l_fit),"displayName")), env.opts.autoescape);
t_8 += "\n\n            </label>\n\n        </div>\n\n     ";
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_8);
});
context.setVariable("_displayFaceoutFit", macro_t_7);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/controls/display-faceout-fits.j2"] , dependencies)